import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import i18n from '@/lang/lang';

import { mapState, mapActions } from 'vuex';
export default {
  name: 'ForeignFactories',
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapState(['roleComponentMenu', 'hasGotForeignList', 'foreignFactoryList'])),
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncForeignFactoryList'])), {}, {
    goToSingleSiteInfo: function goToSingleSiteInfo(fid, siteName) {
      var params = {
        siteName: siteName,
        invLen: 0,
        pvLen: 0,
        anemometerLen: 0,
        fid: fid,
        demo: 'false',
        foreign: 'true'
      };
      if (this.roleComponentMenu.includes('investmentanalysis')) {
        this.$router.push({
          path: "/".concat(i18n.locale, "/siteinfo/investmentanalysis"),
          query: params
        });
      } else {
        this.$swal('權限不足');
        this.$router.push({
          path: "/".concat(i18n.locale, "/realtime")
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.hasGotForeignList && !_this.foreignFactoryList.length)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.asyncForeignFactoryList();
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};